import { all, call, put, takeLatest } from 'redux-saga/effects'
import agent, { mocked } from 'agent'

import getData from 'helpers/getData'
import appMode from 'helpers/getAppMode'
import { exportSaga } from './export.sagas'

import * as actions from 'redux/actions/keywordPages.actions'
import { loadKeywords } from 'redux/actions/domainsData.actions'

function* getPagesSaga(params) {
  try {
    const { domainId, filters } = params.payload
    const [request, requestChanges] = appMode.share
      ? [agent.Share.pages, agent.Share.pagesChanges]
      : appMode.preview
      ? [mocked.Domains.pages, mocked.Domains.pagesChanges]
      : [agent.Domains.pages, agent.Domains.pagesChanges]
    yield all([
      put(loadKeywords(domainId, filters)),
      call(getData, actions.getPagesSuccess, request, domainId, filters)
    ])
    yield all([
      put(actions.getPagesChanges()),
      call(getData, actions.getPagesChangesSuccess, requestChanges, domainId, filters)
    ])
  } catch (error) {
    yield put(actions.getPagesFailure(error))
  }
}

function* exportKeywordPagesExcelSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'xls',
    request: agent.Keywords.exportPagesExcel,
    requestShared: agent.Share.exportSharePagesExcel
  })
}

function* exportKeywordPagesCSVSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'csv',
    request: agent.Keywords.exportPagesCSV,
    requestShared: agent.Share.exportSharePagesCSV
  })
}

export default function* keywordPagesSagas() {
  yield all([
    takeLatest(actions.getPages.type, getPagesSaga),
    takeLatest(actions.exportDomainKeywordPagesExcel.type, exportKeywordPagesExcelSaga),
    takeLatest(actions.exportDomainKeywordPagesCSV.type, exportKeywordPagesCSVSaga)
  ])
}
